import * as fc from "../global/fce.js";
import { Youtube } from "../class/Youtube.js";
import { HodnoceniObchodu } from "../class/HodnoceniObchodu.js";
import { Translation as Tr } from "../class/Translation.js";

function uv_prodejna() {
  var $kod = "";

  $kod +=
    '<div class="leva"> \
    <img src="' +
    $shoptetUpload +
    '/uvod/shop_fotka.jpg"> \
    </div><!-- class="leva"-->';

  $kod +=
    '<div class="prava"> \
    <h2>' +
    Tr.l("uvod_prodejna_h") +
    "</h2>" +
    Tr.l("uvod_prodejna_p") +
    '</div><!-- class="prava"-->';

  return $kod;
} //function  uv_prodejna()

function uv_carousel() {
  if (typeof window.carousel != "object" || !window.carousel.zobrazit)
    return false;

  // $('<div class="owl-carousel"></div>').insertAfter('header#header');

  var $div = '<div class="owl-carousel">';

  window.carousel.polozky.forEach(function(entry) {
    $div +=
      '<div class="item"><a href="' +
      entry.url +
      '"><img src="' +
      $shoptetUpload +
      window.carousel.cesta +
      entry.obr +
      '"></a></div>';
  });

  $div += "</div>";

  return $div;
} //function  uv_carousel()

function uv_bannery() {
  var $kod = "";
  if (!$(".homepage-box .body-banners").length) return false;

  $(".homepage-box .body-banners .banner-wrapper > a").each(function() {
    var $link = $(this).attr("href");
    var $nazev = $(this)
      .find("span.extended-banner-title")
      .text()
      .trim();
    var $src = $(this)
      .find("img")
      .attr("data-src");
    var $textOdkazu = $(this)
      .find(".extended-banner-link")
      .text()
      .trim();
    if (!$textOdkazu.length) $textOdkazu = "více";

    $kod +=
      '<div class="dv">   \
           <a class="obr" href="' +
      $link +
      '"><img src="' +
      $src +
      '">  \
           <h3>' +
      $nazev +
      '</h3>    \
           </a> \
           <a class="link" href="' +
      $link +
      '">' +
      $textOdkazu +
      '</a> \
          </div><!-- class="dv"-->';
  });

  return $kod;
} //function  uv_bannery()

function uv_zobrazNavstiveneProdukty() {
  var $sablona =
    '<div class="product">   \
   <div class="p" itemprop="isRelatedTo" itemscope="" itemtype="https://schema.org/Product">    \
      <a href="%url%" class="image">    \
         <img src="%obr%" alt="">    \
      </a>   \
      <div class="p-in">   \
         <div class="p-in-in">   \
            <a href="%url%" class="name" itemprop="url" title="">    \
                <span itemprop="name">%nazev%</span>   \
            </a>   \
            <div class="cnt">   \
               <div class="prices">   \
                  <div class="price price-final">   \
                     <strong>   \
                     %cena%  \
                     </strong>   \
                  </div>   \
               </div>   \
               <div class="availability">   \
               %dostupnost%  \
               </div>   \
            </div>   \
            <div class="ratings-wrapper">   \
               <div class="stars-placeholder"></div>   \
               <span class="p-code">   \
               Kód: %kod%   \
               </span>   \
            </div>   \
         </div>   \
         <div class="p-bottom single-button">   \
            <div itemscope="" itemprop="offers" itemtype="https://schema.org/Offer">   \
                  <p class="p-desc" itemprop="description"></p>   \
            </div>   \
         </div>   \
      </div>   \
      <span class="p-code">   \
      Kód: %kod%   \
      </span>   \
   </div>   \
</div>';

  $('<div id="products-navstivene" class="products products-block"></div>')
    .insertAfter("#dvCarouObsah")
    .ladzoNavstivene("zobrazProduktySablonou", $sablona, 4);
  if ($("#products-navstivene .product").length) {
    $("#products-navstivene").wrap(
      '<div id="dvNavst" class="container homeBox"/>'
    );
    $("#dvNavst").prepend(
      '<div id="h4Navst" class="h4 homepage-group-title">' +
        Tr.l("uvod_h_naposledy_navstivene") +
        "</div>"
    );
  }

  $("#products-navstivene .price-standard").each(function() {
    if (
      $(this)
        .text()
        .trim() == ""
    )
      $(this)
        .closest(".flag-discount")
        .hide();
  });

  $("#products-navstivene .availability").each(function() {
    if (
      $(this)
        .text()
        .trim() == "%dostupnost%"
    )
      $(this).hide();
  });
} //function  uv_zobrazNavstiveneProdukty()

function uv_aktuality() {
  var $kod = "";

  $("iframe#ifrAktuality").load(function() {
    var $c = $("iframe#ifrAktuality")
      .contents()
      .find("#newsWrapper");
    $c.find(".news-item").each(function() {
      // console.log('sf');
      // console.log(index);
      $kod += '<div class="akt">';
      $kod +=
        '<h3><a href="' +
        $(this)
          .find("a")
          .attr("href") +
        '">' +
        $(this)
          .find("a")
          .text()
          .trim() +
        "</a></h3>";

      var $text = $(this).find(".description");
      var $desc = "";
      if ($text.text().trim() != "...") {
        $desc = $text.html();
      }

      $kod += '<div class="desc">' + $desc + '</div><!-- class="desc"-->';
      //Zveřejněno:
      $kod +=
        '<div class="zv"><span>' +
        $(this)
          .find("time ")
          .text() +
        '</span></div><!-- class="desc"-->';

      $kod += '</div><!-- class="akt"-->';
    });
    /*
          console.log($kod);
          console.log($c);
          console.log($c.length);
          console.log($c.html());
           */

    var $k =
      '<div class="cntmax"><h2>' +
      Tr.l("uvod_aktuality_h") +
      '</h2><div class="cnt">' +
      $kod +
      '</div><div class="c">' +
      Tr.l("uvod_aktuality_a") +
      "</div></div>";

    $("#dvAkt").html($k);
  });
} //function  uv_aktuality()

function uv_JirkaBeran() {
  Lc.f("uv_JirkaBeran");

  var $kod = "";

  //$kod+=el('img[src=""]')
  //<a id="aFan" data-fancybox="" data-type="iframe" href="https://340660.myshoptet.com/kord/?pv24=615%2C618&pv38=1199&pv77=1475&pv56=1460%2C1355&vypisKf=true#iframe">
  $kod += el("h2", Tr.l("uvod_jirka_beran_info_nadpis"));
  $kod += el("p", Tr.l("uvod_jirka_beran_info_text"));

  let $Odk = Tr.obj("uvod_jirka_beran_info_odkazy_neon");
  /*
  let $Odk = {
    "/konfigurace-zbrane/": {
      name: "Konfigurátor zbraně",
      small: "Sestavte si svou zbraň"
    },
    "/video-navody/": {
      name: "Video návody",
      small: "Jak si vybrat boty, masku a další tipy"
    }
  };
  */

  if (!Top.zobrazitKonfiguratorZbrane) {
    delete $Odk["/konfigurace-zbrane/"];
  }
  let $arr = [];
  _.forEach($Odk, function($Val, $url) {
    let $a = el('a[href="' + $url + '"]', $Val.name);
    let $small = $Val.small || "";
    if ($small) $small = el("small", " (" + $small + ")");

    $arr.push($a + $small);
  });

  let $li = "<li>" + fc.implode($arr, "</li><li>") + "</li>";

  let $div = "";

  $div += el("p", el("strong", Tr.l("uvod_jirka_beran_info_doporucuji")));
  $div += el("ul", $li);

  $kod += el("div.dvb", $div);

  return el("div.dva", $kod);
} //function  uv_JirkaBeran()
/*
function uv_videa() {
  var $kod = "";

  $kod += el("h2", "VIDEO NÁVODY, TIPY, RECENZE");

  

  window.youtubeVidea = {
    VUaE1SawReo: "Jak vybrat kolečkovou tašku",
    "6SBRXRYEBXc": "Jak správně vytvarovat masku",
    "VD1KOZ-kGl0": "Základní rozdelení rukavic",
    Thaai4AqwyI: "Jak vybrat šermířské boty"
  };

  var $dvA = "";

  _.forEach(window.youtubeVidea, function($name, $url) {
    //width="560" height="315"
    $dvA +=
      '<div><div class="dvEmb"><iframe src="https://www.youtube.com/embed/' +
      $url +
      '" frameborder="0" allowfullscreen></iframe> \
       </div> \
       </div>';
  });

  $kod += el("div.dvA", $dvA);

  return $kod;
} //function  uv_videa()
*/
export function upravUvodniStranku() {
  $(".wide-carousel").each(function() {
    $(this).wrap('<div id="dvCarousel"></div>');
    $(this)
      .parent()
      .insertBefore("#content-wrapper");
  });

  var $kod = "";

  //--jiri beran doporucuje
  var $fceBeran = uv_JirkaBeran();

  if ($fceBeran.length) {
    $(
      '<div id="dvJB"><div class="cntmax"><div class="cnt">' +
        $fceBeran +
        '</div></div></div><!--id="dvJB" -->'
    ).insertAfter("#content-wrapper");
  }

  //---doporucujeme
  $("#products-1").each(function() {
    var $h4 = $(this).prev(".h4");
    $(this).wrap('<div id="dvDop" class="container homeBox"></div>');
    var $rodic = $(this).parent();
    $h4.prependTo($rodic);
    $h4.text(Tr.l("uvod_jirka_beran_doporucuje_h4"));
    //$rodic.insertAfter('#content-wrapper');
    $rodic.insertAfter($fceBeran.length ? "#dvJB" : "#content-wrapper");
  });

  /*
    //--jiri beran doporucuje
    var $fceVidea=uv_videa();

    if($fceVidea.length){
        $('<div id="dvVid"><div class="cntmax"><div class="cnt">' + $fceVidea + '</div></div></div><!--id="dvJB" -->').insertAfter('#dvDop');
    }

    */

  var $fceVidea = false;
  Youtube.getVideosFromPlaylist({
    playlistID: "PLyHJCoNDCsI1yNjBUps-sNoFps6Vw_rTv",
    apiKey: "AIzaSyAF9n2fBWrpklSEsiDtexUhy7pXNXcy96I",
    max: 4,
    titleMax: 32,
    title: true
  }).then(kod => {
    let $h2 = el("h2", Tr.l("uvod_ytb_h"));
    $(
      '<div id="dvVid"><div class="cntmax">' +
        $h2 +
        '<div class="cnt">' +
        kod +
        '</div></div></div><!--id="dvJB" -->'
    ).insertAfter("#dvDop");
    Youtube.showYoutubeVideos();
    $fceVidea = "ok";
  });

  var $fce = uv_prodejna();
  if ($fce.length)
    $kod +=
      '<div id="dvProdej"><div class="cntmax"><div class="cnt">' +
      $fce +
      '</div></div></div><!--id="dvProdej" -->';

  if ($kod) $($kod).insertAfter($fceVidea.length ? "#dvVid" : "#dvDop");

  //$("#products-6,#products-2")
  $("#products-2").each(function() {
    var $h4 = $(this).prev(".h4");
    $(this).wrap('<div id="dvNov" class="container homeBox"></div>');
    var $rodic = $(this).parent();
    $h4.prependTo($rodic);
    $h4.text(Tr.l("uvod_pr_h_novinky"));
    $rodic.insertAfter("#dvProdej");
  });

  $kod = "";

  $kod +=
    '<div id="dvHodnoceni"><div class="cntmax"></div></div><!--id="dvCarouObsah" -->';

  $fce = uv_carousel();
  if ($fce.length)
    $kod +=
      '<div id="dvCarouObsah"><div class="cntmax">' +
      $fce +
      '</div></div><!--id="dvCarouObsah" -->';

  $fce = uv_bannery();
  if ($fce.length)
    $kod +=
      '<div id="dvBann"><div class="cntmax"><div class="cnt">' +
      $fce +
      '</div></div></div><!--id="dvBann" -->';

  //var $fce=uv_aktuality();
  //if($fce.length)$kod+='<div id="dvAkt"><div class="cntmax"><div class="cnt">' + $fce + '</div></div></div><!--id="dvAkt" -->';
  $kod += '<div id="dvAkt"></div><!--id="dvAkt" -->';

  if ($kod) $($kod).insertBefore("#footer");

  //--HodnoceniObchodu
  HodnoceniObchodu.ziskejHodnoceni({
    max: 4
  }).then(kod => {
    let $h2 = el("h2", Tr.l("uvod_h_hodnoceni_obchodu"));
    $(
      '<div id="dvH"><div class="cntmax">' +
        $h2 +
        '<div class="hodnoceni">' +
        kod +
        '</div></div></div><!--id="dvJB" -->'
    ).appendTo("#dvHodnoceni .cntmax");
  });

  //---------- navstivene
  uv_zobrazNavstiveneProdukty();

  uv_aktuality();

  $(".owl-carousel").owlCarousel({
    items: 1,
    loop: true,
    margin: 10,
    autoplay: true,
    //autoplay:false,
    autoplayTimeout: window.carousel.timeout,
    animateOut: "fadeOut",
    nav: false
    //  autoWidth:true
    //nav:true
  });
} //export function  upravUvodniStranku()
